import React from "react";
import { ApplicationState } from "./../store";
import { actions } from "./../store/PaymentType";
import { connect, ConnectedProps } from "react-redux";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

export const BankAccountOwnerCheckbox: React.FC<BankAccountOwnerCheckboxProps> = (props: BankAccountOwnerCheckboxProps) => {
  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange(event.target.checked);
  };

  return <FormControlLabel control={<Checkbox checked={props.notOwner} onChange={handleOnChange} color='primary' />} label={props.label} />;
};

const connector = connect((state: ApplicationState) => state.payment?.inputs.bankAccountOwner, {
  onChange: actions.notAccountOwnerChanged,
});

type BankAccountOwnerCheckboxProps = ConnectedProps<typeof connector> & {};
export default connector(BankAccountOwnerCheckbox);
